"use client";
import { useRouter } from "@/i18n/routing";
import { useTranslations } from "next-intl";
import Image from "next/image";
export default function Header() {
  const t = useTranslations();
  const router = useRouter();

  return (
    <header className="h-32 bg-[#258966] bg-opacity-30 bg-[url(/bg2.png)] bg-cover bg-right-top">
      <div
        onClick={() => {
          router.push("/");
        }}
        className="absolute left-0 m-2 cursor-pointer p-2 text-2xl transition-transform hover:scale-125"
      >
        <span className="icon-icon6" />
      </div>
      <div className="flex size-full flex-col items-center justify-center py-5">
        <h1>{t("welcome-to")}</h1>
        <Image src="/maha_logo1.webp" alt="maha6 logo" width={200} height={200} />
      </div>
    </header>
  );
}
